import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            width: '100%',
        },
        actions: {
            justifyContent: 'flex-end',
        },
        form: {
            display: 'contents',
        },
        alert: {
            margin: theme.spacing(1, 0),
        },
        title: {
            '& > .MuiTypography-root': {
                display: 'inline-flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: 500,
                maxWidth: 'calc(100% - 24px)',
            },
        },
        action: {
            width: 160,
            minHeight: 0,
            maxWidth: '100%',
            [theme.breakpoints.down('xs')]: {
                width: 120,
            },
        },
    }),
)
